import Vue from 'vue';
import AbstractSortableGrid from './AbstractSortableGrid.vue';
import DeleteDataFileModal from './DeleteDataFileModal.vue';
import Project from 'src/api/project';
import DataUtils from 'src/utils/data';
import FormatUtils from 'src/utils/formatters';
import voiceIcon from 'assets/icons/mic-alt.svg';
import { mapGetters } from 'vuex';
import { debounce } from 'lodash';
import { BfButton, BfTooltipWrapper } from 'components/Butterfly';
import Dropdown from 'components/Butterfly/Dropdown/Dropdown.vue';
import DropdownItem from 'components/Butterfly/Dropdown/DropdownItem.vue';
import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.css';
export default Vue.extend({
    components: { AbstractSortableGrid, BfButton, BfTooltipWrapper, DeleteDataFileModal, Dropdown, DropdownItem, Popper },
    data() {
        return {
            data: {},
            gettingData: false,
            voiceIcon,
            pageNumber: 1,
            sortBy: '',
            sortOptions: [
                { key: '-created', label: 'Recently Added' },
                { key: 'file_name', label: 'Alphanumeric' },
                { key: '-records', label: '# of Records' }
            ],
            getDataFilesDebounced: debounce((pageNumber, sortBy) => {
                if (!this.projectId)
                    return;
                return Project.getDataFiles(pageNumber, this.projectId, sortBy)
                    .then((response) => {
                    // Only apply the payload if the requested page number
                    // is still matching what was set on the widget. It's
                    // possible that the user already navigated to a
                    // different page in the meantime.
                    if (this.pageNumber === pageNumber) {
                        this.pageNumber = response?.pageNumber ?? pageNumber;
                        this.data = response;
                    }
                }).catch(({ status }) => {
                    // We aren't concerned about 401s here because it is either:
                    // 1. The user does not have permission to view the analyses
                    // 2. The user's token has expired.
                    // In scenario 1 - this is handled at the project container level
                    // In scenario 2 - this is handled with a prompt for reauth
                    if (status === 401) {
                        // Redirect to login page here
                        this.$router.push('login');
                    }
                    else if (status !== 401) {
                        throw new Error(`Unhandled API response for Project.getDataFiles, status: ${status}`);
                    }
                }).finally(() => { this.gettingData = false; });
            }, 500),
            dataImportToDelete: null
        };
    },
    computed: {
        ...mapGetters(['currentProject', 'currentUser', 'subscription']),
        dataFiles() {
            return this.data.results;
        },
        rowLimitExceeded() {
            return this.subscription?.projectRowLimit && this.currentProject?.data_units > this.subscription?.projectRowLimit;
        },
        projectId() {
            return this.$route.params.projectId;
        },
        isDataProcessing() {
            // analysis.statuses
            // inprogress: processing, updating, created, pending
            // done: Finished, error
            return this.currentProject.processing ||
                !!this.currentProject?.analyses?.find(a => !['FINISHED', 'ERROR'].includes(a.status.toUpperCase()));
        },
    },
    mounted() {
        this.sortBy = this.sortOptions[0].key;
        this.getDataFiles(1, this.sortBy, true);
    },
    methods: {
        getDataFileError(df) {
            if (df.status_text.includes('Missing unique identifiers')
                || df.status_text.includes('Invalid date format')) {
                return df.status_text;
            }
            return 'Oops! Something went wrong processing this file. Click to hide this error message permanently.';
        },
        number: FormatUtils.number,
        formatDate: DataUtils.formatDate,
        getDataFiles(pageNumber, sortBy, force = false, background = false) {
            if (force || (pageNumber !== this.pageNumber)) {
                this.gettingData = !background;
                this.pageNumber = pageNumber;
                this.sortBy = sortBy;
                return this.getDataFilesDebounced(pageNumber, sortBy, force);
            }
        },
        async deleteDataImport(autoUpdateOnDelete) {
            const dataFileId = this.dataImportToDelete.id;
            await Project.deleteDataFile(dataFileId, autoUpdateOnDelete);
            this.$analytics.track.project.deleteData(false, this.currentProject.id);
            this.dataImportToDelete = null;
            await this.getDataFiles(this.pageNumber, this.sortBy, true);
        },
        // Delete a file in the Error state
        deleteErroredFile(dataFile) {
            if (dataFile.status === 'ERROR') {
                this.dataImportToDelete = dataFile;
            }
            this.$analytics.track.project.deleteData(true, this.currentProject.id);
        },
    }
});
